<template>
    <div class="product-map__filter" :class="{ 'is-open': open }">
        <div class="product-map__filter-drop-down bg--white" @click="open = !open">
            <span class="product-map__filter-label">
                {{ activeCategory ? activeCategory.title : "Filter by type" }}
            </span>

            <span class="product-map__filter-toggle text--blue product-map__filter-toggle--desk">
                <BaseIcon icon="chevron-down-icon" class="product-map__filter-icon" />
            </span>

            <span class="desk--hidden bg--blue product-map__filter-toggle text--white product-map__filter-toggle--portable">
                <svg class="product-map__filter-icon product-map__filter-icon--open" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 11">
                    <path stroke="inherit" stroke-linecap="round" stroke-linejoin="round" d="M1 .7h11M10.875 4.688V9.5M13.375 8l-2.5 2.5M8.375 8l2.5 2.5M1 4.7h6.2M1 8.7h2.6"/>
                </svg>
                <BaseIcon icon="cross-icon" class="product-map__filter-icon product-map__filter-icon--close"/>
            </span>
        </div>

        <div class="product-map__tabs bg--white">
            <div class="product-map__filter-heading h5">Filter</div>
            
            <ul class="product-map__tabs-list">
                <li class="product-map__tab product-map__tab--view-all" :class="{ active: !activeCategory }" @click.prevent="selectCategory(null)">
                    View all
                </li>
                <li
                    v-for="category in categories"
                    :key="category.slug"
                    class="product-map__tab"
                    :class="{[`product-map__tab--${category.slug}`]: true, active: activeCategory === category }"
                    @click.prevent="selectCategory(category)"
                >
                    {{ category.title }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        categories: {
            type: Array,
            required: true
        },

        map: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            open: true,
            activeCategory: null
        }
    },

    mounted() {
        const isDesktop = window.matchMedia('(min-width: 1024px)');
        this.open = isDesktop.matches;
    },

    methods: {
        selectCategory(category) {
            this.activeCategory = category;
            this.close();
            this.$emit('update:selected', category);
        },
        
        close() {
            this.open = false;
        }
    }
}
</script>